import React from "react";
import ReactDOM from "react-dom";
import registerServiceWorker from "./registerServiceWorker";
// Components
import App from "./components/App";
// Routes
import createRoutes from "./routes";
import "./theme.css";
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/select/lib/css/blueprint-select.css";
import { FocusStyleManager } from "@blueprintjs/core";
// Redux
import { createStore, combineReducers, applyMiddleware } from "redux";
import reducers from "./reducers";
import { Provider } from "react-redux";
// Middleware
// More on thunk: https://github.com/gaearon/redux-thunk#motivation
import thunk from "redux-thunk";
import { createLogger } from "redux-logger";
import analytics from "./analytics";
// React router redux
// For intercepting and dispatching navigation actions
// More: https://github.com/ReactTraining/react-router/tree/master/...
// .../packages/react-router-redux
// Note: it allows you to dispatch navigation actions from anywhere
// E.g.: store.dispatch(push('/foo'))
import {
  ConnectedRouter,
  routerReducer,
  routerMiddleware
} from "react-router-redux";
// Create a history (browser history in this case)
import createHistory from "history/createBrowserHistory";

const history = createHistory();

// Create store with reducer and middleware
const middlewares = [
  analytics,
  thunk,
  routerMiddleware(history)
];

if (process.env.NODE_ENV === `development`) {
  middlewares.push(createLogger());
}

const createStoreWithMiddleware = applyMiddleware(...middlewares)(createStore);

const store = createStoreWithMiddleware(
  combineReducers({
    ...reducers,
    routing: routerReducer
  })
);

// Root element
const root = (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App routes={createRoutes(store)}/>
    </ConnectedRouter>
  </Provider>
);

// Only show focus on tab
FocusStyleManager.onlyShowFocusOnTabs();

// Mount root element
ReactDOM.render(root, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js